"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosCacheInterceptor = void 0;
const hub_utilities_replenishment_1 = require("@yw/hub.utilities.replenishment");
const configurations_1 = require("../../configurations");
const utils_1 = require("./utils");
class AxiosCacheInterceptor {
    constructor(axiosInstance, storage) {
        this.axiosInstance = axiosInstance;
        this.storage = storage;
    }
    setupInterceptor() {
        this.addRequestInterceptor();
        this.addResponseInterceptor();
    }
    isTitularGet(config) {
        var _a, _b;
        return (((_a = config === null || config === void 0 ? void 0 : config.method) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'get' ||
            ((_b = config === null || config === void 0 ? void 0 : config.normalizeMethod) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === 'get');
    }
    addRequestInterceptor() {
        this.axiosInstance.registerRequestInterceptor((config) => {
            if (this.isTitularGet(config) && config.cache) {
                const cacheKey = this.getCacheKey(config);
                if (this.storage.has(cacheKey)) {
                    const cacheData = this.storage.get(cacheKey);
                    return Promise.resolve(Object.assign(Object.assign({}, config), { adapter: () => Promise.resolve(cacheData) }));
                }
            }
            return config;
        });
    }
    addResponseInterceptor() {
        this.axiosInstance.registerResponseInterceptor((response) => {
            if (this.isTitularGet(response.config) && response.config.cache) {
                const cacheKey = this.getCacheKey(response.config);
                const cacheConfig = (0, hub_utilities_replenishment_1.merge)(configurations_1.defaultCacheConfig, response.config.cacheConfig);
                if (!this.storage.has(cacheKey)) {
                    this.storage.set(cacheKey, response, {
                        expiresTime: cacheConfig.expiresTime,
                        expiresAfter: cacheConfig.expiresAfter,
                        encrypted: cacheConfig.encrypted,
                    });
                }
            }
            return response;
        });
    }
    getCacheKey(config) {
        const { method, url, params, data } = config;
        return `${method}-${url}-${(0, utils_1.qs)(params || {})}-${(0, utils_1.qs)(data || {})}`;
    }
}
exports.AxiosCacheInterceptor = AxiosCacheInterceptor;
//# sourceMappingURL=AxiosCacheInterceptor.js.map